import { z } from 'zod';
// form
export const newsletterFormSchema = (emailEmpty = '', emailInvalid = '') => z.object({
    email: z
        .string()
        .min(1, emailEmpty !== null && emailEmpty !== void 0 ? emailEmpty : '')
        .email(emailInvalid !== null && emailInvalid !== void 0 ? emailInvalid : ''),
});
//# sourceMappingURL=Newsletter.types.js.map